/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */
import { useState, useEffect, useMemo } from 'react';
import { Helmet } from 'react-helmet';
import { Api } from '../../../api';
import { CommonTable } from '../../../component/common/table2/CommonTable';
import moment from 'moment';
import ConfirmPopup from '../../../component/common/modals/ConfirmPopup';
import { successToast } from '../../../utils/helper';

function Peapapproval() {
  const [loading, setLoading] = useState(false);
  const [approvalsList, setApprovalsList] = useState([]);
  const [confirmationPopup, setConfirmationPopup] = useState(false);
  const [selectedId, setSelectedId] = useState(null);
  const [checkedId, setCheckedId] = useState(null);

  /* COLUMNS */
  const columns = useMemo(() => [
    {
      accessorKey: 'name',
      header: 'Expert name',
      cell: ({ row }) => {
        return (
          <div className="text-left">
            <div className="text-xs font-normal text-black dark:text-white">
              {row?.original?.expert_user_id?.first_name} {row?.original?.expert_user_id?.last_name}
            </div>
          </div>
        );
      },
      enableSorting: false,
      enableHiding: false
    },
    {
      accessorKey: 'action',
      header: 'Description',
      cell: ({ row }) => {
        return (
          <div className="text-left">
            <div className="text-xs font-normal text-black dark:text-white">
              {row?.original?.notes ? row?.original?.notes : 'Request to send report to the client'}
            </div>
          </div>
        );
      },
      enableSorting: false,
      enableHiding: false
    },
    {
      accessorKey: 'client_name',
      header: 'Client Name',
      cell: ({ row }) => {
        return (
          <div className="text-left">
            <div className="text-xs font-normal text-black dark:text-white">
              {row?.original?.users_user_id?.name ??
                row?.original?.session_id?.client_user_id?.first_name ??
                row?.original?.session_id?.client_user_id?.name}{' '}
              {row?.original?.session_id?.client_user_id?.last_name ?? ''}
            </div>
          </div>
        );
      },
      enableSorting: false,
      enableHiding: false
    },
    {
      accessorKey: 'requested_on',
      header: 'Requested On',
      cell: ({ row }) => {
        return (
          <div className="text-left">
            <div className="text-xs font-normal text-black dark:text-white">
              {moment(row?.original?.requested_on).format('MMM DD, YYYY')}
            </div>
          </div>
        );
      },
      enableSorting: false,
      enableHiding: false
    },
    {
      accessorKey: 'approve',
      header: 'Approved?',
      cell: ({ row, index }) => {
        const isApproved = row?.original?.status === 2;
        const currentId = row?.original?._id;

        return (
          <div className="text-center">
            <input
              type="checkbox"
              className="cursor-pointer h-4 w-4 rounded border border-[blue] accent-shoorah-primary sm:left-6"
              checked={isApproved || checkedId === currentId}
              disabled={isApproved}
              onChange={() => {
                if (!isApproved) {
                  setCheckedId(currentId);
                  setSelectedId(currentId);
                  setConfirmationPopup(true);
                }
              }}
            />
          </div>
        );
      },
      enableSorting: false,
      enableHiding: false
    }
  ]);

  /* FETCH DATA */
  const fetchData = async () => {
    try {
      setLoading(true);
      const response = await Api.getApprovalsList();
      console.log('🚀 ~ Fetching Data ~ response:', response);
      setApprovalsList(response.data.data);
    } catch (error) {
      console.error('🚀 ~ Fetching Data ~ error:', error);
    } finally {
      setLoading(false);
    }
  };

  /* HANDLE STATUS */
  const handleStatus = async () => {
    try {
      const response = await Api.updateApprovalsStatus({ requestId: selectedId, status: 2 });
      if (response?.status === 200) {
        successToast('Request has been approved successfully');
        fetchData();
        setConfirmationPopup(false);
        setCheckedId(null);
      }
    } catch (error) {
      console.error('🚀 ~ handleStatus ~ error:', error);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  if (loading) {
    return (
      <div className="flex justify-center items-center h-64">
        <div className="text-lg">Loading approvals...</div>
      </div>
    );
  }

  return (
    <div className="relative">
      <Helmet>
        <meta charSet="utf-8" />
        <title>Approvals | Peap Management</title>
      </Helmet>

      <div className="mt-5 p-6 bg-white rounded-2xl dark:border-shoorah-darkBorder border-[1.5px] dark:bg-shoorah-darkBgTabColor border-shoorah-borderGray">
        <CommonTable data={approvalsList} columns={columns} noExtraRow />
      </div>

      {confirmationPopup && (
        <ConfirmPopup
          open={confirmationPopup}
          setOpen={setConfirmationPopup}
          message={'Are you sure you want to approve this request?'}
          setAccepted={handleStatus}
          handleNo={() => {
            setConfirmationPopup(false);
            setCheckedId(null);
          }}
        />
      )}
    </div>
  );
}

export default Peapapproval;
